export default{
    methods: {
        minwidth(){

        },
        maxwidth(){

        },
        winWidth: function () {
           // setInterval(() => {
                var w = window.innerWidth;
                if (w < 600) {
                    this.minwidth();
                } else {
                    this.maxwidth();
                }
           // }, 200);
        }
    },
    mounted() {
        this.winWidth();
    }
}